import * as React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import usePlatform from "../../../hooks/usePlatform"
import mobileFunnelDataSample from "../../../assets/images/funnel/funnel_data_sample_mobile.png"
import funnelDataSample from "../../../assets/images/funnel/funnel_data_sample.png"
import mobileFunnelDataSampleEn from "../../../assets/images/funnel/funnel_data_sample_mobile_en.png"
import funnelDataSampleEn from "../../../assets/images/funnel/funnel_data_sample_en.png"
import { Locale } from "../../../locale"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#E8EFFC",
    },
    wrapper: {
      boxSizing: "border-box",
      width: "100%",
      padding: "0 20px",
      "& img": {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: "1248px",
        margin: "0 auto",
        fontSize: 0,
      },
    },
  })
)

export default function DataSample() {
  const classes = useStyles()
  const { isMobile } = usePlatform()
  const { lang } = Locale.getDefault()
  // const { ref } = useScrollImpressionLog({
  //   message: "3. SDK 연동시 자동으로",
  //   eventKey: `homepage_funnel_section_3_impression`,
  // })
  return (
    <div className={classes.root}>
      {lang === "ko" ? (
        <div className={classes.wrapper}>{<img src={isMobile ? mobileFunnelDataSample : funnelDataSample} />}</div>
      ) : (
        <div className={classes.wrapper}>{<img src={isMobile ? mobileFunnelDataSampleEn : funnelDataSampleEn} />}</div>
      )}
    </div>
  )
}
